import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import React from 'react'
import { HomeUpdatesDto } from '../../../Component/Model/Dto/Home/Home';
import { CustomDialogTitle } from '../../Common/Custom/CustomDialogTitle';

interface IProps {
    open: boolean,
    onClose: () => void;
    data : HomeUpdatesDto.Response;
}

export const UpdatesModal = (props: IProps) => {
    return (
        <Dialog disableEnforceFocus open={props.open} onClose={props.onClose} aria-labelledby="form-dialog-title" maxWidth='lg'>
            <CustomDialogTitle id="personcheck-dialog-title" onClose={props.onClose}>
                {props.data.title}
            </CustomDialogTitle>
            <DialogContent>
                <Grid container margin={1}>
                    <Grid item xs={12}>
                        <div dangerouslySetInnerHTML={{ __html: props.data.content }} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                {props.data.url && <Button color="secondary" variant='text' component="a" href={props.data.url} target="_blank">View Article</Button>}
            </DialogActions>
        </Dialog>
    )
}
